var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 12.4783C35.3587 12.4783 29.8443 14.151 25.1539 17.2851C20.4636 20.4191 16.8079 24.8735 14.6491 30.0852C12.4904 35.2969 11.9256 41.0317 13.0261 46.5643C14.1266 52.097 16.843 57.1791 20.8319 61.1679C24.8207 65.1568 29.9028 67.8732 35.4355 68.9737C40.9681 70.0742 46.7029 69.5094 51.9146 67.3507C57.1262 65.1919 61.5807 61.5362 64.7147 56.8458C67.8487 52.1555 69.5215 46.6411 69.5215 41C69.5215 33.4356 66.5166 26.181 61.1677 20.8321C55.8188 15.4832 48.5642 12.4783 40.9998 12.4783V12.4783ZM32.3165 52.0918L32.3165 29.9082L54.6427 41L32.3165 52.0918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPlay);
export default __webpack_public_path__ + "static/media/status-play.16b7f2aef5778de111fff57dcbe87edd.svg";
export { ForwardRef as ReactComponent };